import microApp, { getActiveApps } from '@micro-zoe/micro-app'
import { useTransition } from 'react'
import { useNavigate } from 'react-router-dom'
import { joinpath } from '../utils'

interface IOptions {
  /**
   * 主应用Name
   */
  appName?: string
  /**
   * 主应用路由
   */
  appBaseRoute?: string
  /**
   * 是否为主应用，0否，1是
   */
  isMainApp?: boolean
  /**
   * 路由配置
   */
  routeOptions?: {
    replace?: boolean
    state?: any
    preventScrollReset?: boolean
    relative?: any
    unstable_flushSync?: boolean
    unstable_viewTransition?: boolean
  }
}

/**
 * 跳转地址
 * @returns
 */
export const useAppNavigate = () => {
  const _window = window as any
  const navigate = useNavigate()
  const [isPending, startTransition] = useTransition()

  const toApp = (to: string, options?: any) => {
    startTransition(() => {
      navigate(to, options)
    })
  }

  return (to: string | any, options?: IOptions) => {
    const { appName = '', appBaseRoute = '', routeOptions = {} } = options || {}
    if (!appName) {
      console.log('不存在appName时跳转：', to)
      toApp(joinpath(appBaseRoute || '', to), routeOptions)
    } else {
      if (!getActiveApps().includes(appName)) {
        console.log('应用未激活时跳转：', appName, '-', to)
        toApp(joinpath(appBaseRoute || '', to), routeOptions)
      } else {
        console.log('应用激活时跳转：', appName, '-', to)
        // 使用forceSetData，当路由未变化时，也强制发送
        microApp.forceSetData(appName, { path: to })
      }
    }
  }
}
